<div class="drip-program-container" *ngIf="dripProgram && !loading">
	<!-- Drip Program Selection at the top -->
	<div class="drip-program-selection">
		<div class="field">
			<label for="drip-program-name">Drip Program</label>
			<div class="p-inputgroup">
				<p-dropdown id="drip-program-name" [options]="dripPrograms" [optionLabel]="'dripProgramDesc'" [optionValue]="'dripProgramID'" [(ngModel)]="selectedDripProgramID" (onChange)="onProgramSelectionChange($event.value)" placeholder="Select Drip Program"></p-dropdown>
				<div class="button primary" (click)="addProgram()">Add Program</div>
				<div class="button danger" [class.disabled]="selectedDripProgramID === defaultDripProgramID" (click)="selectedDripProgramID !== defaultDripProgramID && deleteProgram()">Delete Program</div>
			</div>
		</div>
	</div>

	<div class="program-header">
		<div class="field">
			<label for="program-name">
				Program Name
				<span class="material-symbols-outlined info-icon" [pTooltip]="'The name of this Drip Program. The default program cannot be renamed.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
			</label>
			<input pInputText type="text" id="program-name" [(ngModel)]="dripProgram.dripProgramDesc" [disabled]="selectedDripProgramID === defaultDripProgramID" (ngModelChange)="markDirty()" />
		</div>

		<div class="field">
			<label for="start-date">
				Program Start Date
				<span class="material-symbols-outlined info-icon" [pTooltip]="'This is the first date the Drip Program can start. If the start date is today or earlier, the program will run as scheduled.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
			</label>
			<p-calendar id="start-date" [(ngModel)]="dripProgram.startDate" [showTime]="false" [dateFormat]="'mm/dd/yy'" (ngModelChange)="markDirty()" />
		</div>

		<div class="field">
			<label for="delivery-time">
				Time of Day to Deliver
				<span class="material-symbols-outlined info-icon" [pTooltip]="'Times are shown in your local time. This is when Drip emails will begin sending. Delivery may continue for up to one hour after this time.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
			</label>
			<p-calendar id="delivery-time" [(ngModel)]="deliveryTimeDate" [timeOnly]="true" [hourFormat]="'12'" (ngModelChange)="markDirty()" />
		</div>

		<div class="field pause-field">
			<label for="pause">
				Pause
				<span class="material-symbols-outlined info-icon" [pTooltip]="'Pauses all Drip emails until this option is unchecked. No emails will be sent while paused.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
			</label>
			<p-checkbox id="pause" [(ngModel)]="dripProgram.paused" [binary]="true" (ngModelChange)="markDirty()" />
		</div>

		<div class="field">
			<label for="catchup-days">
				Days Between Catchup Emails
				<span class="material-symbols-outlined info-icon" [pTooltip]="'If a recipient is behind on the Drip schedule, Catchup emails will be sent with this many days between each one.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
			</label>
			<input pInputText type="number" id="catchup-days" [(ngModel)]="dripProgram.catchUpInterval" min="0" (ngModelChange)="markDirty()" />
		</div>
	</div>

	<div class="emails-section">
		<div class="section-header">
			<h2>Email Sequence</h2>
			<div class="button primary" (click)="showAddCampaignDialog()">Add Campaign</div>
		</div>
		<p class="drag-instructions">Drag and drop emails to reorder the sequence</p>
		<div class="email-table">
			<div class="table-header">
				<div class="column campaign">Campaign</div>
				<div class="column days-after">Days After Prior Email <span class="material-symbols-outlined info-icon" [pTooltip]="'The number of days to wait after the previous Drip email before sending the next one. The first email in the program is usually set to 0.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span></div>
				<div class="column catchup">Catchup</div>
				<div class="column actions">Actions</div>
				<div class="column drag-header"></div>
			</div>

			<div cdkDropList (cdkDropListDropped)="dropEmail($event)" class="table-body">
				<div class="table-row draggable" *ngFor="let email of emails; let i = index" cdkDrag>
					<div class="column campaign">{{ email.campaignName }}</div>
					<div class="column days-after">
						<input pInputText type="number" [(ngModel)]="email.interval" min="0" class="interval-input" (ngModelChange)="markDirty()" />
					</div>
					<div class="column catchup">
						<p-checkbox [(ngModel)]="email.catchup" [binary]="true" (ngModelChange)="markDirty()" />
					</div>
					<div class="column actions">
						<button pButton pRipple icon="pi pi-trash" class="p-button-text p-button-danger" (click)="removeCampaign(i)" title="Remove Campaign"></button>
					</div>
					<div class="drag-handle" cdkDragHandle>
						<i class="pi pi-bars"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="loading-container" *ngIf="loading">
	<p>Loading drip program...</p>
</div>

<!-- Campaign Selection Dialog -->
<p-dialog [(visible)]="showCampaignDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false" header="Select Campaign to Add" [style]="{ width: '600px' }" (onHide)="closeCampaignDialog()">
	<div class="campaign-dialog-content">
		<div class="search-section">
			<div class="p-inputgroup">
				<span class="p-inputgroup-addon">
					<i class="pi pi-search"></i>
				</span>
				<input type="text" pInputText placeholder="Search campaigns..." [(ngModel)]="campaignSearchTerm" (input)="filterCampaigns()" />
			</div>
		</div>

		<div class="campaigns-list" *ngIf="filteredAvailableCampaigns.length > 0">
			<div class="campaign-item" *ngFor="let campaign of filteredAvailableCampaigns" (click)="selectCampaignToAdd(campaign)">
				<div class="campaign-info">
					<h4>{{ campaign.campaignName }}</h4>
					<p class="campaign-subject">{{ campaign.eMailSubject }}</p>
				</div>
				<button pButton pRipple icon="pi pi-plus" class="p-button-text p-button-sm" title="Add Campaign"></button>
			</div>
		</div>

		<div class="no-campaigns" *ngIf="filteredAvailableCampaigns.length === 0">
			<p>No campaigns found matching your search.</p>
		</div>
	</div>

	<ng-template pTemplate="footer"> </ng-template>
</p-dialog>

<!-- Dirty state program-switch dialog -->
<p-dialog [(visible)]="dirtySwitchDialogVisible" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false" header="Unsaved changes" [style]="{ width: '500px' }">
	<p>You have unsaved changes. Do you want to save before switching programs?</p>
	<ng-template pTemplate="footer">
		<button pButton type="button" label="Save" class="p-button-success" (click)="onDirtySave()"></button>
		<button pButton type="button" label="Discard" class="p-button-warning" (click)="onDirtyDiscard()"></button>
		<button pButton type="button" label="Cancel" class="p-button-secondary" (click)="onDirtyCancel()"></button>
	</ng-template>
</p-dialog>
